import careseeker from "../../../assets/png/careseeker.png";
import confianceImage from "../../../assets/png/confiance.png";
import homecare from "../../../assets/png/homecare.png";
import useTranslation from "../../../hooks/useTranslation";
import styles from "./VMVValeurs.module.scss";

function VMVValeurs() {
  const { t } = useTranslation();

  const valeursList: {
    image: string;
    text: string;
  }[] = [
      {
        image: confianceImage,
        text: t('components.vmvValues.values.0'),
      },
      {
        image: homecare,
        text: t('components.vmvValues.values.1'),
      },
      {
        image: careseeker,
        text: t('components.vmvValues.values.2'),
      },
    ];

  return (
    <article className={styles.vmvValeurs}>
      <h1>
        {t('components.vmvValues.title')}
      </h1>
      <article className={styles.vmvValeurs__valeurs}>
        {valeursList.map((valeur, index) => {
          return (
            <section
              key={`VMV_valeur_${index}`}
              className={styles.vmvValeurs__valeurs__item}
            >
              <figure
                style={{ backgroundImage: `url(${valeur.image})` }}
              ></figure>
              <p>{valeur.text}</p>
            </section>
          );
        })}
      </article>
    </article>
  );
}

export default VMVValeurs;
